import { createSelector } from 'reselect'
import equipmentRequestIsPendingSelector from '../pending-request/equipmentRequestIsPendingSelector'
import modelsForCarlineRequestIsPendingSelector from '../pending-request/modelsForCarlineRequestIsPendingSelector'
import technicalDataRequestIsPendingSelector
    from '../pending-request/technicalDataRequestIsPendingSelector'

const targetNavigationIsLoadingSelector = createSelector(
    modelsForCarlineRequestIsPendingSelector,
    equipmentRequestIsPendingSelector,
    technicalDataRequestIsPendingSelector,
    (modelRequestIsPending, equipmentRequestIsPending, technicalDataRequestIsPending): boolean => (
        modelRequestIsPending || equipmentRequestIsPending || technicalDataRequestIsPending
    ),
)

export default targetNavigationIsLoadingSelector
